
import React, { useEffect } from 'react';
import { useAuthStore } from '@/stores';

// Legacy compatibility hook - use useAuthStore directly in new components
export const useAuth = () => {
  const auth = useAuthStore();
  return {
    user: auth.user,
    session: auth.session,
    loading: auth.loading,
    signIn: auth.signIn,
    signUp: auth.signUp,
    signOut: auth.signOut,
    resetPassword: auth.resetPassword,
    updatePassword: auth.updatePassword,
    updateEmail: auth.updateEmail,
  };
};

export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { initialize } = useAuthStore();

  useEffect(() => {
    initialize();
  }, [initialize]);

  return <>{children}</>;
};
